export default __webpack_public_path__ + "static/media/acpc_home_brand.00700006.jpg";